import React from 'react';
import Calendar from './Calendar';

function App() {
  return (
    <div>
      {/* <h1 style={{ textAlign: 'center' }}>My Calendar</h1> */}
      <Calendar />
    </div>
  );
}

export default App;
